<!-- 
HACCP情報ユーザーの一覧画面
@props
  itemList : ユーザー一覧として表示するユーザー情報の配列
-->

<template>
  <div>
    <v-data-table
      locale="jp"
      mobile-breakpoint="0"
      v-model="selected"
      :headers="headers"
      :items="itemList"
      :single-select="false"
      :custom-sort="sortFunction"
      item-key="uid"
      show-select
      hide-default-footer
      :search="searchCondition"
      :custom-filter="executeSearch"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      @page-count="pageCount = $event"
      no-results-text="検索条件に合うデータがありません"
      no-data-text="データがありません"
    >
      <!-- 表上部の検索フィールド -->
      <template v-slot:top>
        <v-row class="mb-0" align="center">
          <v-col cols="auto" sm="8" md="5" lg="3" xl="3">
            <v-text-field
              v-model="search"
              class="mx-4"
              outlined
              dense
              hide-details
              @keyup.enter.exact="requestToSearch"
            >
              <template v-slot:prepend>
                <v-icon>mdi-magnify</v-icon>
              </template>
              <template v-slot:append-outer>
                <v-btn
                  outlined
                  color="primary"
                  style="margin-top: -6px"
                  @click="requestToSearch"
                  >検索</v-btn
                >
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </template>
      <!-- ヘッダの定義 -->
      <template v-slot:[`header.data-table-select`]="{ props, on }">
        <v-simple-checkbox
          :value="props.value || props.indeterminate"
          v-on="on"
          :indeterminate="props.indeterminate"
          dark
          :ripple="false"
        />
      </template>
      <template v-slot:[`header.group`]>
        <all-open-button
          :title="headers[1].text"
          @on-change-open-state="onChangeJoinGroup"
        ></all-open-button>
      </template>
      <!-- 表示するセルのフォーマットの定義 -->
      <template v-slot:[`item.group`]="{ item }">
        <tooltips
          :ref="'groupTooltips.' + item.uid"
          :data="item.group"
          :max="3"
          class="fixed-width-300"
        ></tooltips>
      </template>
      <template v-slot:[`item.userName`]="{ item }">
        <td>
          <v-btn
            color="primary"
            class="fixed-width-300 text-truncate text-none"
            text
            @click.stop="showDetail(item.uid)"
          >
            {{ item.userName }}
          </v-btn>
        </td>
      </template>
      <template v-slot:[`item.outputCsv`]="{ item }">
        <v-chip
          v-if="(dispFlag && item.flagProducer) || (useridFlag == item.uid && item.flagProducer)"
          color="primary"
          dark
          label
          @click.stop="outputCsv(item.userName, item.uid)"
        >
          出力
        </v-chip>
      </template>
      <template v-slot:[`item.outputShipping`]="{ item }">
        <td>
        <v-chip
            v-if="(rootGroupFlag && item.flagProducer) || (useridFlag == item.uid && item.flagProducer)"
            color="primary"
            dark
            label
            @click.stop="shippingList(item.userName, item.uid)"
        >
          表示
        </v-chip>
        </td>
      </template>
    </v-data-table>
    <div class="text-center pt-2">
      <v-pagination
        v-model="page"
        :length="pageCount"
        :total-visible="7"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import Tooltips from "../common/tooltips.vue";
import AllOpenButton from "../common/all-open-button.vue";
import valueConverter from "../../logic/common/value-converter";

export default {
  props: ["itemList"],
  components: {
    tooltips: Tooltips,
    "all-open-button": AllOpenButton,
  },
  data() {
    // ボタン表示フラグ
    this.dispFlag = this.$store.getters.csvPermission;
    this.rootGroupFlag = this.$store.getters.userGroupIds.includes('root');
    if(this.$store.getters.flagProducer){
      this.prodFlag = true;
    }else {
      this.prodFlag = false;
    }
    // ログインユーザーのuserId
    this.useridFlag = this.$store.getters.userId;
    // メニューボタン表示フラグ
    if (this.dispFlag || this.$store.getters.flagProducer) {
      if(this.rootGroupFlag || this.prodFlag){
        return {
          // 検索条件（入力中）
          search: "",
          // 検索条件（一覧反映中）
          searchCondition: "",
          // 表示中のページ番号
          page: 1,
          // ページ数
          pageCount: 0,
          // ページあたりに表示するユーザー件数
          itemsPerPage: 20,
          // 選択中のユーザー情報
          selected: [],
          // 一覧のヘッダ定義
          headers: [
            {
              text: "ユーザー名",
              align: "start",
              value: "userName",
              class: "grey darken-1 white--text pl-8",
              width: "50%",
            },
            {
              text: "所属グループ",
              align: "start",
              value: "group",
              class: "grey darken-1 white--text",
              width: "50%",
              sortable: false,
            },
            {
              text: "最終更新日",
              align: "start",
              value: "lastUpdate",
              class: "grey darken-1 white--text",
              width: "200px",
            },
            {
              text: "CSV出力",
              align: "start",
              value: "outputCsv",
              class: "grey darken-1 white--text",
              width: "150px",
            },
            {
              text: "出荷量一覧",
              align: "start",
              value: "outputShipping",
              class: "grey darken-1 white--text",
              width: "150px",
            },
          ],
        };
      }else{
        return {
          // 検索条件（入力中）
          search: "",
          // 検索条件（一覧反映中）
          searchCondition: "",
          // 表示中のページ番号
          page: 1,
          // ページ数
          pageCount: 0,
          // ページあたりに表示するユーザー件数
          itemsPerPage: 20,
          // 選択中のユーザー情報
          selected: [],
          // 一覧のヘッダ定義
          headers: [
            {
              text: "ユーザー名",
              align: "start",
              value: "userName",
              class: "grey darken-1 white--text pl-8",
              width: "50%",
            },
            {
              text: "所属グループ",
              align: "start",
              value: "group",
              class: "grey darken-1 white--text",
              width: "50%",
              sortable: false,
            },
            {
              text: "最終更新日",
              align: "start",
              value: "lastUpdate",
              class: "grey darken-1 white--text",
              width: "200px",
            },
            {
              text: "CSV出力",
              align: "start",
              value: "outputCsv",
              class: "grey darken-1 white--text",
              width: "200px",
            },
          ],
        };
      }
    } else if(this.rootGroupFlag || this.prodFlag) {
      return {
        // 検索条件（入力中）
        search: "",
        // 検索条件（一覧反映中）
        searchCondition: "",
        // 表示中のページ番号
        page: 1,
        // ページ数
        pageCount: 0,
        // ページあたりに表示するユーザー件数
        itemsPerPage: 20,
        // 選択中のユーザー情報
        selected: [],
        // 一覧のヘッダ定義
        headers: [
          {
            text: "ユーザー名",
            align: "start",
            value: "userName",
            class: "grey darken-1 white--text pl-8",
            width: "50%",
          },
          {
            text: "所属グループ",
            align: "start",
            value: "group",
            class: "grey darken-1 white--text",
            width: "50%",
            sortable: false,
          },
          {
            text: "最終更新日",
            align: "start",
            value: "lastUpdate",
            class: "grey darken-1 white--text",
            width: "200px",
          },
          {
            text: "出荷量一覧",
            align: "start",
            value: "outputShipping",
            class: "grey darken-1 white--text",
            width: "150px",
          },
        ],
      };
    } else {
      return {
        // 検索条件（入力中）
        search: "",
        // 検索条件（一覧反映中）
        searchCondition: "",
        // 表示中のページ番号
        page: 1,
        // ページ数
        pageCount: 0,
        // ページあたりに表示するユーザー件数
        itemsPerPage: 20,
        // 選択中のユーザー情報
        selected: [],
        // 一覧のヘッダ定義
        headers: [
          {
            text: "ユーザー名",
            align: "start",
            value: "userName",
            class: "grey darken-1 white--text pl-8",
            width: "50%",
          },
          {
            text: "所属グループ",
            align: "start",
            value: "group",
            class: "grey darken-1 white--text",
            width: "50%",
            sortable: false,
          },
          {
            text: "最終更新日",
            align: "start",
            value: "lastUpdate",
            class: "grey darken-1 white--text",
            width: "200px",
          },
        ],
      };
    }
  },
  methods: {
    /**
     * すべて開く/すべて閉じるボタンを押下した
     */
    onChangeJoinGroup(state) {
      Object.keys(this.$refs)
        .filter((key) => key.startsWith("groupTooltips."))
        .forEach((key) => {
          const item = this.$refs[key];
          if (item) {
            item.setEllipsisState(!state);
          }
        });
    },
    /**
     * 並び替えをカスタマイズする
     */
    sortFunction(items, sortBy, sortDesc) {
      if (sortBy.length == 0) {
        const userId = this.$store.getters.userId;
        return valueConverter.dataTableCustomSort(
          items,
          ["userName"],
          [false],
          (a, b) => {
            // ログインユーザーと同じIDであれば先頭に表示する
            if (userId == a.uid) {
              return -1;
            }
            if (userId == b.uid) {
              return 1;
            }
            // ログインユーザー以外のユーザーはデフォルトの比較方法で判定を行う
            return undefined;
          }
        );
      }
      return valueConverter.dataTableDefaultSort(items, sortBy, sortDesc);
    },
    /**
     * HACCP情報を表示する
     */
    showDetail(uid) {
      this.$router.push(`/product/detail/${uid}`);
    },
    /**
     * 検索条件を一覧に反映する
     */
    requestToSearch() {
      this.searchCondition = this.search;
    },
    /**
     * 検索を実施する
     */
    executeSearch(_, search, item) {
      if (search == null) {
        return true;
      }
      // ユーザー名で部分一致検索する
      const userName = item.userName;
      // グループ名で部分一致検索する
      const groups = item.group.map((g) => g.name).join(" ");
      // 最終更新日時で部分一致検索する
      const lastUpdate = item.lastUpdate;
      if (userName.includes(search)) {
        return true;
      }
      if (lastUpdate.includes(search)) {
        return true;
      }
      if (groups.includes(search)) {
        return true;
      }
      return false;
    },
    /**
     * CSV出力を実施する
     */
    outputCsv(name, uid) {
      this.$router.push(`/outputCsv/${name}/${uid}`);
    },
    /**
     * 生産者の出荷先ごとの出荷量一覧を表示する
     */
    shippingList(name, uid) {
      this.$router.push(`/shipmentList/${name}/${uid}`);
    },
  },
};
</script>

<style>
th {
  background-color: #757575 !important;
}
th.sortable .v-data-table-header__icon {
  color: rgb(255, 255, 255, 0.15) !important;
}
th.sortable.active .v-data-table-header__icon {
  color: rgb(255, 255, 255, 1) !important;
}
</style>
